import { createActions } from 'redux-actions';
import keyMirror from 'key-mirror';

export const constants = keyMirror({
    GET_SCHOOL_REQUEST: null,
    GET_SCHOOL_SUCCESS: null,
    GET_SCHOOL_FAILURE: null,

    GET_SINGLE_SCHOOL_REQUEST: null,
    GET_SINGLE_SCHOOL_SUCCESS: null,
    GET_SINGLE_SCHOOL_FAILURE: null
});

export const {
    getSchoolRequest,
    getSchoolSuccess,
    getSchoolFailure
} = createActions(
    constants.GET_SCHOOL_REQUEST,
    constants.GET_SCHOOL_SUCCESS,
    constants.GET_SCHOOL_FAILURE
);

export const {
    getSingleSchoolRequest,
    getSingleSchoolSuccess,
    getSingleSchoolFailure
} = createActions(
    constants.GET_SINGLE_SCHOOL_REQUEST,
    constants.GET_SINGLE_SCHOOL_SUCCESS,
    constants.GET_SINGLE_SCHOOL_FAILURE
);



/** WEBPACK FOOTER **
 ** ./src/core/school/schoolActions.js
 **/